import Vue from 'vue';
import TICKET_CALL_TYPE from '../components/devices/Infoscreen/helpers/TicketCallType';
import { WINDOW_TYPE } from '@/constants/WindowType';
import parsePhoneNumber from 'libphonenumber-js';

export function parseJSON(jsonData) {
  return new Promise((resolve, reject) => {
    try {
      const parsedJsonData = JSON.parse(jsonData);
      resolve(parsedJsonData);
    } catch(error) {
      console.warn(`Произошла ошибка при попытке парсинга`, jsonData);
      reject(error);
    }
  });
}

export function createGlobalStore(data) {
  if (!Vue.prototype.$store) {
    var shared = new Vue({
      data: data
    });

    shared.install = function() {
      Object.defineProperty(Vue.prototype, '$store', {
        get() { return shared }
      });
    }

    Vue.use(shared);

    console.log('Глобальное хранилище инициализировано', data);
  }
}

export function asyncTimeout(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export function generateAudioCallByTicket(audioNotifier, ticket, ticketCallType = TICKET_CALL_TYPE.SHORT_VOICE) {
  const windowIsCabinet = ticket.window && ticket.window.type === WINDOW_TYPE.CABINET;

  let audioSequence = [];

  switch (ticketCallType) {
  case TICKET_CALL_TYPE.GONG:
    audioSequence = audioNotifier.getAudioByKey('call');
    break;

  case TICKET_CALL_TYPE.SHORT_VOICE:
    audioSequence = [
      ...audioNotifier.getAudioByKey('call'),
      ...audioNotifier.getAudioByKey('visitor_number'),
      ...audioNotifier.generateAudioByChars(ticket.prefix),
      ...audioNotifier.generateAudioByNumber(ticket.number),
      ...audioNotifier.getAudioByKey(ticket.window.type),
      ...(windowIsCabinet ? audioNotifier.generateAudioByString(ticket.window.number) : [...audioNotifier.generateAudioByNumber(ticket.window.number)])
    ];
    break;

  case TICKET_CALL_TYPE.VOICE:
    audioSequence = [
      ...audioNotifier.getAudioByKey('call'),
      ...audioNotifier.getAudioByKey('visitor_number'),
      ...audioNotifier.generateAudioByChars(ticket.prefix),
      ...audioNotifier.generateAudioByNumber(ticket.number),
      ...audioNotifier.getAudioByKey(`go_to_${ticket.window.type}_number`),
      ...(windowIsCabinet ? audioNotifier.generateAudioByString(ticket.window.number) : [...audioNotifier.generateAudioByNumber(ticket.window.number)])
    ];
    break;
  }

  return audioNotifier.playAudioSequence(audioSequence);
}

export function getAllComponentRefs(vueComponent) {
  return Object.values(vueComponent.$refs).reduce((references, element) => {
    return Array.isArray(refs) ? references.push(...element) : references.push(element);
  });
}

export function getHeightRatioParentToChild(childElement) {
  const currentElementHeight = childElement.scrollHeight;
  const parentElementHeight = childElement.parentElement.offsetHeight;
  return parentElementHeight / currentElementHeight;
}

export function getRatioFittedInContainer(textElement, containerElement) {
  if (!textElement) throw new Error(`Text element should be defined`)
  containerElement = containerElement || textElement.parentElement;
  return getHeightRatioBetweenChildAndParent(textElement);
}

export function openFullscreen() {
  const documentElement = document.documentElement;

  if (documentElement.requestFullscreen) {
    documentElement.requestFullscreen();
  } else if (documentElement.webkitRequestFullscreen) {
    documentElement.webkitRequestFullscreen();
  } else if (documentElement.msRequestFullscreen) {
    documentElement.msRequestFullscreen();
  }
}

export function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

function getTranslationList(translationConsts, translationKeys) {
  return translationKeys.map((translationKey) => translationConsts[translationKey]);
}

export function getMonthsTranslation(translationConsts) {
  const translationKeys = [
    'infoscreen_weather_month_jan',
    'infoscreen_weather_month_feb',
    'infoscreen_weather_month_mar',
    'infoscreen_weather_month_apr',
    'infoscreen_weather_month_may',
    'infoscreen_weather_month_jun',
    'infoscreen_weather_month_jul',
    'infoscreen_weather_month_aug',
    'infoscreen_weather_month_sep',
    'infoscreen_weather_month_oct',
    'infoscreen_weather_month_nov',
    'infoscreen_weather_month_dec'
  ];

  return getTranslationList(translationConsts, translationKeys);
}

export function getWeekdaysTranslation(translationConsts) {
  const translationKeys = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday"
  ];

  return getTranslationList(translationConsts, translationKeys);
}

export function formatPhoneNumber(phoneNumber) {
  try {
    if(phoneNumber) {
      return parsePhoneNumber(`+${phoneNumber}`).formatInternational()
    }
  } catch (err) {
  }
  return '';
}

export function isObject(data) {
  return data && typeof data === 'object' && !Array.isArray(data)
}
